// Load components
import { gridDebug } from "./tools/grid-debug";
import { burgerMenu } from "./components/burger";
import { stickyHeader } from "./components/sticky-header";
import { FloatLabel } from "./components/form";
import { Modal } from "./components/modal";
import Slider from "./components/sliders";

const mql = window.matchMedia("(max-width: 1199px)");

const target = document.querySelector("#lang-select");

const observer = new MutationObserver((mutationsList, observer) => {
	for (const mutation of mutationsList) {
		if (mutation.type === "childList" || mutation.type === "subtree") {
			prisna_hide_current_lang();
		}
	}
});

observer.observe(target, {
	childList: true,
	subtree: true,
});

const getSpaceBetweenHeaderAndContainer = () => {
	const first_ctn = document.querySelector(".header__inner").getBoundingClientRect().left;
	const second_ctn = document.querySelectorAll(".container")[0].getBoundingClientRect().left;
	document.body.style.setProperty("--_offset-header-start", `${first_ctn}px`);
	document.body.style.setProperty("--_offset-x-start", `${second_ctn - first_ctn}px`);
};

	// Issue when submiting AJAX form -> Convert to vanilla if you DARE !!
jQuery(document).bind("gform_post_render", function () {
	FloatLabel.init();
});

/**
 * Gravity Forms 3.x datepicker (WhatSock / AccDC)
 * - Injecte le bouton toggle attendu par AccDC
 * - Désactive les help texts injectés dans le champ
 * - Repositionne le calendrier dans les modales (overflow)
 */
const setupGformDatepicker = () => {
	const ensureDatepickerToggles = (root = document) => {
		root.querySelectorAll("input.gform-datepicker").forEach((input) => {
			const container = input.closest(".ginput_container_date") || input.parentElement;
			if (!container || container.querySelector("button.gform-datepicker-toggle")) return;

			const button = document.createElement("button");
			button.type = "button";
			button.id = `datepicker_toggle_${input.id}`;
			button.className = "gform-datepicker-toggle gform-datepicker-toggle--default accCalendar aria-date-picker";
			button.setAttribute("aria-expanded", "false");
			button.setAttribute("aria-controls", input.id);
			button.setAttribute("aria-label", "Choisir une date");
			button.innerHTML = '<span class="gform-datepicker-toggle-icon" aria-hidden="true"></span>';
			container.appendChild(button);
		});
	};

	ensureDatepickerToggles();

	if (window.gform?.utils?.addFilter) {
		window.gform.utils.addFilter("gform/datepicker/pre_init", (payload) => {
			if (payload?.options) {
				payload.options.openOnFocus = true;
				payload.options.helpTextShort = "";
				payload.options.helpText = "";
				payload.options.openOnFocusHelpText = "";
			}
			return payload;
		});
	}

	let activeDateInput = null;
	let activeScrollContainer = null;
	let rafId = null;

	const getDatepicker = () => {
		const calendar = document.querySelector(".gform-datepicker-calendar:not([hidden])");
		if (calendar) return calendar;

		const legacy = document.getElementById("ui-datepicker-div");
		if (legacy && legacy.style.display !== "none") return legacy;

		return null;
	};

	const resetActiveInput = () => {
		activeDateInput = null;
		if (activeScrollContainer) {
			activeScrollContainer.removeEventListener("scroll", queuePositionUpdate);
			activeScrollContainer = null;
		}
	};

	const queuePositionUpdate = () => {
		if (rafId) window.cancelAnimationFrame(rafId);
		rafId = window.requestAnimationFrame(updateDatepickerPosition);
	};

	const updateDatepickerPosition = () => {
		rafId = null;

		if (!activeDateInput || !document.body.contains(activeDateInput)) {
			resetActiveInput();
			return;
		}

		const modal = activeDateInput.closest(".modal.is-visible");
		if (!modal) {
			resetActiveInput();
			return;
		}

		const datepicker = getDatepicker();
		if (!datepicker) return;

		const inputRect = activeDateInput.getBoundingClientRect();
		const pickerRect = datepicker.getBoundingClientRect();
		const gutter = 8;
		let top = inputRect.bottom + gutter;
		let left = inputRect.left;

		if (top + pickerRect.height > window.innerHeight - gutter) {
			top = Math.max(gutter, inputRect.top - pickerRect.height - gutter);
		}

		const maxLeft = Math.max(gutter, window.innerWidth - pickerRect.width - gutter);
		left = Math.min(Math.max(gutter, left), maxLeft);

		datepicker.style.position = "fixed";
		datepicker.style.top = `${Math.round(top)}px`;
		datepicker.style.left = `${Math.round(left)}px`;
		datepicker.style.zIndex = "9999";
	};

	const setActiveInput = (input) => {
		const modal = input?.closest(".modal.is-visible");
		if (!modal) {
			resetActiveInput();
			return;
		}

		activeDateInput = input;

		const nextScrollContainer = modal.querySelector(".modal__dialog");
		if (activeScrollContainer !== nextScrollContainer) {
			if (activeScrollContainer) {
				activeScrollContainer.removeEventListener("scroll", queuePositionUpdate);
			}
			activeScrollContainer = nextScrollContainer;
			if (activeScrollContainer) {
				activeScrollContainer.addEventListener("scroll", queuePositionUpdate, { passive: true });
			}
		}

		queuePositionUpdate();
		window.setTimeout(queuePositionUpdate, 0);
		window.setTimeout(queuePositionUpdate, 50);
	};

	document.addEventListener("focusin", (event) => {
		const input = event.target.closest("input.gform-datepicker");
		if (!input) return;
		setActiveInput(input);
	});

	document.addEventListener("click", (event) => {
		const trigger = event.target.closest("button.gform-datepicker-toggle, img.ui-datepicker-trigger");
		if (!trigger) return;

		const input = trigger.parentElement?.querySelector("input.gform-datepicker");
		if (!input) return;
		setActiveInput(input);
	});

	document.addEventListener("click", (event) => {
		if (!event.target.closest(".gform-datepicker-calendar, #ui-datepicker-div .ui-datepicker-prev, #ui-datepicker-div .ui-datepicker-next, #ui-datepicker-div .ui-datepicker-title select")) return;
		window.setTimeout(queuePositionUpdate, 0);
	});

	window.addEventListener("resize", queuePositionUpdate);
	window.addEventListener("scroll", queuePositionUpdate);

	if (window.jQuery) {
		window.jQuery(document).on("gform_post_render gform_page_loaded", (_event, formId) => {
			const form = formId ? document.getElementById(`gform_${formId}`) : document;
			ensureDatepickerToggles(form || document);
			window.requestAnimationFrame(queuePositionUpdate);
		});
	}
};

document.addEventListener("DOMContentLoaded", (e) => {
	setTimeout(() => {
		prisna_hide_current_lang();
	}, 1000);

	// Load grid debug on dev environement
	if (themeVars.is_dev) gridDebug.init();

	// Init components
	burgerMenu.init();
	stickyHeader.init();
	FloatLabel.init();
	Modal.init();
	setupGformDatepicker();

	document.body.style.setProperty("--_header-h", `${document.querySelector(".header").getBoundingClientRect().height}px`);

	// Sticky CTA
	const sticky_anchor = document.querySelector(".fgdc-sticky-anchor__label");
	if (sticky_anchor) {
		let scroll_pos = window.scrollY;
		document.body.style.setProperty("--_sticky-btn-w", `${sticky_anchor.getBoundingClientRect().width}px`);

		window.addEventListener("scroll", function () {
			scroll_pos = window.scrollY;
			sticky_anchor.parentElement.classList.toggle("is-visible", scroll_pos >= 30);
		});
	}

	// Get Offset header
	getSpaceBetweenHeaderAndContainer();
	window.addEventListener("resize", () => {
		getSpaceBetweenHeaderAndContainer();
		document.body.style.setProperty("--_header-h", `${document.querySelector(".header").getBoundingClientRect().height}px`);
	});

	// Header : Open searchbar
	const mini_searchform = document.querySelector(".mini-searchform");
	if (mini_searchform) {
		const mini_searchform_trigger = mini_searchform.querySelector(".mini-searchform__trigger");
		const mini_searchform_input = mini_searchform.querySelector('input[type="search"');
		mini_searchform_trigger.addEventListener("click", (e) => {
			mini_searchform.classList.toggle("is-open");
			setTimeout(() => {
				mini_searchform_input.focus();
			}, 10);
		});

		document.addEventListener("mouseup", (e) => {
			if (!e.target.closest(".mini-searchform__form")) {
				mini_searchform.classList.remove("is-open");
			}
		});
	}

	// Menu
	let header = document.querySelector(".header");
	let menu_with_complex_nav = document.querySelectorAll(".has-complex-nav");
	if (menu_with_complex_nav) {
		menu_with_complex_nav.forEach((link) => {
			link.addEventListener("mouseover", () => {
				header.classList.add("drop-nav-open");
			});

			link.addEventListener("mouseout", () => {
				header.classList.remove("drop-nav-open");
			});
		});
	}

	// News carousel slider
	const news_slider = document.querySelectorAll(".news-slider");
	if (news_slider) {
		news_slider.forEach((slider) => {
			const swiper = slider.querySelector(".swiper");
			if (swiper) {
				Slider.initSwiper(swiper, {
					loop: true,
					effect: "fade",
					slidesPerView: 1,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				});
			}
		});
	}

	/**
	 * ============================
	 * Search filters
	 * ============================
	 */
	let partnersCategoriesInputs = document.querySelectorAll('input[name="partner-categories[]"]');
	if (partnersCategoriesInputs.length > 0) {
		partnersCategoriesInputs.forEach((input) => {
			input.addEventListener("change", () => {
				let checkedValues = Array.from(partnersCategoriesInputs)
					.filter((input) => input.checked)
					.map((input) => input.value);

				let take_new_patients = document.querySelector(".take-new-patients-container");
				take_new_patients.classList.remove("shown");

				if (checkedValues.includes("medecins")) take_new_patients.classList.add("shown");
				else {
					document.getElementById("take_new_patients").checked = false;
					take_new_patients.classList.remove("shown");
				}
			});
		});
	}

	// init all select with class "tom-select"
	const tom_selects = document.querySelectorAll("select.tom-select");
	if (tom_selects) {
		let tomSelectOptions = {
			plugins: {
				remove_button: {
					title: "Remove this item",
				},
			},
			create: false,
			allowEmptyOptions: true,
			placeholder: "",
			onFocus: () => {
				let selects = document.querySelectorAll("select.tom-select");
				if (selects) {
					selects.forEach((tomSelect, index) => {
						if (window["tomSelect-" + index].input.name !== "npa" && window["tomSelect-" + index].input.name !== "letter") {
							window["tomSelect-" + index].control_input.setAttribute("readonly", true);
							window["tomSelect-" + index].control.style.cursor = "pointer";
						}
					});
				}
			},
			onInitialize: function () {
				let placeholderValue = this.input.dataset.placeholder;
				if (placeholderValue && this.getValue().length == 0) {
					let placeholder = document.createElement("span");
					placeholder.className = "ts-placeholder";
					placeholder.innerText = this.input.dataset.placeholder;
					this.control.prepend(placeholder);
				}
			},
			onChange: function (value) {
				let placeholder = this.control.querySelector("span.ts-placeholder");
				if (placeholder) {
					if (value.length > 0) placeholder.classList.add("d-none");
					else placeholder.classList.remove("d-none");
				}
			},
		};

		let tomSelectLetterOptions = {
			plugins: {
				remove_button: {
					title: "Remove this item",
				},
			},
			create: false,
			placeholder: "",
			valueField: "id",
			labelField: "name",
			searchField: ["name"],
			loadThrottle: 300,
			onInitialize: function () {
				this.wrapper.classList.add("tomselect-letters");
				let placeholderValue = this.input.dataset.placeholder;
				if (placeholderValue && this.getValue().length == 0) {
					let placeholder = document.createElement("span");
					placeholder.className = "ts-placeholder";
					placeholder.innerText = this.input.dataset.placeholder;
					this.control.prepend(placeholder);
				}
			},
			load: function (query, callback) {
				const ts = this;
				ts.clearOptions();

				query = query.trim();
				if (query.length < 2) {
					ts.addOption({ id: "__more_letters__", name: themeVars.tomselect.more_letters });
					ts.refreshOptions(false);
					return callback();
				}

				ts.addOption({ id: "__loading__", name: themeVars.tomselect.loading });
				ts.refreshOptions(false);

				jQuery.ajax({
					url: themeVars.ajaxUrl,
					type: "POST",
					data: {
						action: "fgdc",
						function: "search_partners_by_letters",
						data: { value: query },
					},
					success: function (data) {
						ts.clearOptions();

						if (!data || data.length === 0) {
							ts.addOption({ id: "__noresult__", name: themeVars.tomselect.noresult });
							ts.refreshOptions(false);
							return callback();
						}

						callback(data);
					},
					error: function () {
						ts.clearOptions();
						ts.addOption({ id: "__error__", name: themeVars.tomselect.error });
						ts.refreshOptions(false);
						callback();
					},
				});
			},
			render: {
				no_results: function(data, escape) {
					if(data.input.length < 2) {
						return '<div class="ts-option-disabled option" data-selectable>'+ themeVars.tomselect.more_letters +'</div>';
					}
					return '<div class="no-results">'+ themeVars.tomselect.noresult +'</div>';
				},
				option: function (item, escape) {
					if (item.id && item.id.startsWith("__")) {
						return `<div class="ts-option-disabled">${escape(item.name)}</div>`;
					}
					return `<div>${escape(item.name)}</div>`;
				},
			},
			onChange: function (value) {
				if (value && !value.startsWith("__")) {
					let partnerType = document.querySelector('input[id="partner-category-all"]');
					if (partnerType) partnerType.checked = true;

					const npaTomSelectEl = document.querySelector(".partners-filters-npa");
					if (npaTomSelectEl && npaTomSelectEl.tomselect) {
						npaTomSelectEl.tomselect.clear(true);
						document.querySelector(".ts-wrapper.partners-filters-npa .ts-placeholder").classList.remove("d-none");
					}

					let checkedValues = Array.from(partnersCategoriesInputs)
						.filter((input) => input.checked)
						.map((input) => input.value);

					let take_new_patients = document.querySelector(".take-new-patients-container");
					take_new_patients.classList.remove("shown");

					if (checkedValues.includes("medecins")) take_new_patients.classList.add("shown");
					else {
						let checkbox = take_new_patients.querySelector(".take_new_patients");
						checkbox.checked = false;

						take_new_patients.classList.remove("shown");
					}
				}
			},
			onFocus: function () {
				const placeholder = this.control.querySelector(".ts-placeholder");
				const input = this.control.querySelector('input[type="text"]');
				if (placeholder) placeholder.style.display = "none";
				if (input) {
					input.style.setProperty("display", "inline-block", "important");
					input.focus();
				}
			},
			onBlur: function () {
				if (!this.getValue()) {
					const placeholder = this.control.querySelector(".ts-placeholder");
					const input = this.control.querySelector('input[type="text"]');
					if (placeholder) placeholder.style.display = "block";
					if (input) input.style.setProperty("display", "none", "important");
				}
			},
		};

		tom_selects.forEach((tom_select, index) => {
			if (window["tomSelect-" + index] == undefined) window["tomSelect-" + index] = new TomSelect("select[data-tom-select-id='" + tom_select.dataset.tomSelectId + "']", tom_select.getAttribute("name") == "letter" ? tomSelectLetterOptions : tomSelectOptions);
		});
	}

	// Search partners selects
	let searchPartners = document.querySelectorAll(".provider-form");
	if (searchPartners.length > 0) {
		searchPartners.forEach(function (element, index) {
			let submitBtn = element.querySelector('button[type="submit"]');
			submitBtn.addEventListener("click", function (e) {
				e.preventDefault();
				let selectedValue = element.querySelector("select option:checked").value;
				if (selectedValue.length > 0) {
					window.location.href = themeVars.archivePartners + "/categorie/" + selectedValue + "/";
				}
			});
		});
	}

	// Popup
	const popup = document.querySelector(".popup");
	if (popup) {
		const popupSeen = localStorage.getItem("popupSeen");

		if (!popupSeen) {
			popup.classList.remove("is-popup-hidden");
		}

		const popupClose = popup.querySelector(".popup__close");

		popupClose.addEventListener("click", (e) => {
			e.preventDefault();

			popup.classList.add("is-popup-hidden");

			localStorage.setItem("popupSeen", "true");
		});
	}

	if (mql.matches) {
		// Filters listing
		const triggerFilters = document.querySelector(".js-trigger-filters-md");
		if (triggerFilters) {
			triggerFilters.addEventListener("click", (e) => {
				e.currentTarget.parentElement.classList.toggle("is-open");
			});
		}

		const filtersCtn = document.querySelector(".filters");
		const btnSubmitFilters = document.querySelector(".btn-submit-filters");
		if (filtersCtn && btnSubmitFilters) {
			btnSubmitFilters.addEventListener("click", (e) => {
				if (filtersCtn.classList.contains("is-open")) {
					filtersCtn.classList.remove("is-open");
				}
			});
		}

		// Navigation
		const navHasChildren = document.querySelectorAll(".has-childrens");
		navHasChildren.forEach((item) => {
			const link = item.querySelector(".main-nav__link");

			item.addEventListener("click", (e) => {
				// Empêcher le comportement par défaut si le lien a un href="#"
				if (link && link.getAttribute("href") === "#") {
					e.preventDefault();
				}

				// Vérifier l'état actuel de l'élément cliqué
				const isOpen = item.classList.contains("is-open");

				// Fermer tous les sous-menus sauf le courant
				navHasChildren.forEach((drop) => {
					if (drop !== item) {
						drop.classList.remove("is-open");
					}
				});

				// Ouvrir ou fermer le sous-menu du lien cliqué en fonction de son état précédent
				if (!isOpen) {
					item.classList.add("is-open");
				} else {
					item.classList.remove("is-open");
				}
			});

			// Empêcher la propagation de l'événement de clic sur les sous-menus
			const subMenus = item.querySelectorAll(".subnav__link, .drop-nav__heading");
			subMenus.forEach((subItem) => {
				subItem.addEventListener("click", (e) => {
					e.stopPropagation();
				});
			});
		});

		// Dropnavs
		let triggers_drop_nav = document.querySelectorAll("[data-trigger-sub]");
		triggers_drop_nav.forEach((trigger) => {
			trigger.addEventListener("click", (e) => {
				let target = e.currentTarget.dataset.triggerSub;
				let currentMenu = document.querySelector(`[data-nav="${target}"]`);

				// Vérifier si le menu cliqué est déjà ouvert
				let isAlreadyOpen = currentMenu.classList.contains("is-open");

				// Fermer tous les sous-menus
				document.querySelectorAll("[data-nav]").forEach((drop) => {
					drop.classList.remove("is-open");
				});

				// Basculer l'état du menu cliqué seulement s'il n'était pas déjà ouvert
				if (!isAlreadyOpen) {
					currentMenu.classList.add("is-open");
				}
			});
		});

		// Footer navs mobile
		let footer_navs_child = document.querySelectorAll(".footer-nav__has-chidlrens");
		footer_navs_child.forEach((nav) => {
			const trigger = nav.querySelector(".footer-nav__arrow");
			trigger.addEventListener("click", (e) => {
				// Vérifier l'état actuel de l'élément cliqué
				const isOpen = e.currentTarget.parentElement.parentElement.classList.contains("is-open");

				// Fermer tous les sous-menus sauf le courant
				footer_navs_child.forEach((drop) => drop.classList.remove("is-open"));

				// Ouvrir ou fermer le sous-menu du lien cliqué en fonction de son état précédent
				if (!isOpen) {
					trigger.parentElement.parentElement.classList.add("is-open");
				} else {
					trigger.parentElement.parentElement.classList.remove("is-open");
				}
			});
		});
	}
});

function prisna_hide_current_lang() {
	let prisnaLangSwitcher = document.querySelector("#lang-select .prisna-translator");
	if (prisnaLangSwitcher) {
		let prisnaLanguages = prisnaLangSwitcher.querySelectorAll(".prisna-wp-translate-languages-list p span");
		prisnaLanguages.forEach((lang) => {
			let langParent = lang.closest("p");
			langParent.style.display = "block";
		});

		let prisnaCurrentLang = prisnaLangSwitcher.querySelector(".prisna-wp-translate-current-language span");
		let prisnaCurrentLangClass = prisnaCurrentLang.classList.value;

		prisnaLanguages.forEach((lang) => {
			let langParent = lang.closest("p");
			let langClass = lang.classList.value;

			if (langClass == prisnaCurrentLangClass) langParent.style.display = "none";
			else langParent.style.display = "block";
		});
	}
}
